// Modal.tsx
import React from "react";
import { Order } from "../../Interfaces/Orders";
import "./OrderDetailsModal.css"; // You can move related styles to a separate file.

interface OrderDetailsModalProps {
  order: Order | null;
  isOpen: boolean;
  onClose: () => void;
}

const OrderDetailsModal: React.FC<OrderDetailsModalProps> = ({
  order,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !order) {
    return null;
  }

  return (
    <div className="warehouse-order-display-modal">
      <div className="warehouse-order-display-modal-content">
        <span className="warehouse-order-display-close" onClick={onClose}>
          &times;
        </span>
        <div className="warehouse-order-display-modal-body">
          <div className="warehouse-order-display-modal-details">
            <h3>Order Details</h3>
            <p>
              <strong>Order Number:</strong> {order.order_id}
            </p>
            <p>
              <strong>Order Date:</strong> {order.created_at.split("T")[0]}
            </p>
            <p>
              <strong>Order Status:</strong> {order.latest_status.status}
            </p>
            <h4>Products:</h4>
            <ul>
              {order.orderlineitem_set.map((product) => (
                <li key={product.id}>
                  {product.product.item_display_name} (Qty: {product.quantity})
                </li>
              ))}
            </ul>
          </div>
          <div className="warehouse-order-display-modal-shipping-info">
            <h4>Shipping Info:</h4>
            <p>
              <strong>Name:</strong> {order.shipping_info?.ship_to_name}
            </p>
            <p>
              <strong>Address:</strong> {order.shipping_info?.street_address}
            </p>
            <p>
              <strong>City:</strong> {order.shipping_info?.city}
            </p>
            <p>
              <strong>State:</strong> {order.shipping_info?.state}
            </p>
            <p>
              <strong>Zipcode:</strong> {order.shipping_info?.zip_code}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;
